import React from "react";
import BankPackets from "./bankpackets";

const Nbi = (props) => {
  return <BankPackets />;
};

export default Nbi;
